import { TERM_CLASSIFICATION_OPTIONS } from './courseTerms.js';

const legacyTypes = {
  semester_1: 'first_semester',
  summer: 'summer_intensive',
  semester_2: 'second_semester',
  winter: 'winter_intensive',
};
const knownTypes = new Set([...TERM_CLASSIFICATION_OPTIONS.map(item => item.value), 'other']);

// Match stored identities/types, never the display label (which may include a year).
export function timetableTermType(course, terms = []) {
  const identity = course.term || course.semester;
  const term = terms.find(item => (item.id || item.value) === identity);
  const type = course.termType || term?.termType || identity;
  return knownTypes.has(type) ? type : legacyTypes[type] || null;
}

export function timetableTermOptions(courses, terms, year) {
  const hasOther = courses.some(course => course.active !== false &&
    String(course.year || new Date().getFullYear()) === String(year) && timetableTermType(course, terms) === 'other');
  return hasOther ? [...TERM_CLASSIFICATION_OPTIONS, { value: 'other', label: '기타 (기존)' }] : TERM_CLASSIFICATION_OPTIONS;
}
